<template>
<section class="input-container">
    <div class="label">
        <p><i class="icon-required" v-if="transProp.validations.presence === '1'">*</i>{{transProp.label}}:</p>
        <van-icon name="question-o" class="question" v-if="transProp.notes" @click="showNotes" />
    </div>
    <div class="inp-f">
        <input type="text" class="inp-s" v-model="value" @input="handleSearch" name="">
    </div>
    <ul class="name-list" v-show="emailsData.length > 0">
        <li v-for="item in emailsData" @click="handleChange(item)">{{item}}</li>
    </ul>
    <div class="form-error" v-show="showError">
        {{setErrorMsg(transProp)}}
    </div>
</section>
</template>

<script>
import { Icon } from "vant";
export default {
  props: {
    transProp: Object,
    index: Number
  },
  components: {
    "van-icon": Icon
  },
  data() {
    return {
      value: "",
      emailsData: [],
      showError: false,
      emails: [
        "gmail.com",
        "yahoo.com",
        "qq.com",
        "163.com",
        "msn.com",
        "hotmail.com",
        "aol.com",
        "ask.com",
        "live.com",
        "0355.net",
        "163.net",
        "263.net",
        "3721.net",
        "yeah"
      ]
    };
  },
  methods: {
    showNotes() {
      this.$emit("input", this.index);
    },
    // 提交时拿取当前参数
    collectOptions() {
      let options = {
        code: this.transProp.code,
        value: this.value
      };
      return options;
    },
    setErrorMsg(t) {
      return t.rules ? t.rules.message : `${t.label}不可为空`;
    },
    handleSearch() {
      let reg = /@/;
      if (this.value) {
        let emailsData = [];
        if (reg.test(this.value)) {
          let index = this.value.indexOf("@");
          let str = this.value.substr(index + 1);
          let regTest = new RegExp("^" + str, "i");
          let formerValue = this.value.substr(0, index + 1);
          emailsData = this.emails
            .filter(i => {
              return regTest.test(i);
            })
            .map(e => {
              return `${formerValue}${e}`;
            });
        } else {
          emailsData = this.emails.map(item => {
            return `${this.value}@${item}`;
          });
        }

        this.emailsData = emailsData;
      } else {
        this.emailsData = [];
      }
      this.validate();
    },
    handleChange(item) {
      this.value = item;
      this.emailsData = [];
      this.validate();
    },
    validate() {
      if (this.transProp.rules) {
        if (!this.transProp.rules.pattern.test(this.value)) {
          this.showError = true;
          return {
            label: this.transProp.label,
            boo: true
          };
        }
        this.showError = false;
        return {
          label: this.transProp.label,
          boo: false
        };
      } else {
        return { label: this.transProp.label, boo: false };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.input-container {
  .label {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .question {
      color: #999090;
      font-size: 32px;
    }
  }

  .inp-f {
    margin: 8px 0;

    .inp-s {
      color: #666;
    }
  }

  .name-list {
    border: 1px solid #d9d9d9;
    padding: 0 24px 20px;
    max-height: 400px;
    overflow-y: auto;

    li {
      margin-top: 20px;
      color: #666;
    }
  }
}
</style>
